// Authorization section form field enum
export enum AuthorizationFormField {
  AUTHORIZATION_AUTHORIZATION_AUTHORIZATION_SOURCE = 'authorization/authorization/authorization-source',
  AUTHORIZATION_AUTHORIZATION_CURRENT_HOURS = 'authorization/authorization/current-hours',
  AUTHORIZATION_ACUTE_PERIOD_CURRENT_ACTIVE = 'authorization/acute-period/current-active',
  AUTHORIZATION_ACUTE_PERIOD_PERIOD = 'authorization/acute-period/period'
}
